/**
 * KAN-623: правила профиля Telegram-аккаунта: инициалы, лимиты полей, проверка фото.
 */

export const NAME_MAX = 64;
export const ABOUT_MAX = 70;
export const PHOTO_MAX_BYTES = 5 * 1024 * 1024;
export const PHOTO_TYPES = ['image/jpeg', 'image/png'];
export const PROFILE_SAVED = 'Профиль обновлён';
export const SAVE_ERROR = 'Не удалось изменить профиль';
export const RATE_WARNING =
  'Частая смена профиля может привести к ограничениям Telegram. Меняйте профиль не чаще раза в несколько дней.';

/** null: файл подходит, иначе текст ошибки. */
export function validatePhoto(file: File): string | null {
  if (!PHOTO_TYPES.includes(file.type)) return 'Нужен файл JPEG или PNG';
  if (file.size > PHOTO_MAX_BYTES) return 'Файл больше 5 МБ';
  return null;
}

/** Первая буква слова (любого алфавита), пропуская цифры и знаки. */
function firstLetter(word: string): string {
  return word.match(/\p{L}/u)?.[0] ?? '';
}

/**
 * Инициалы только из букв: до двух слов имени (или username). Без имени:
 * первая латинская буква метки. "" значит показать иконку.
 */
export function profileInitials(name: string, label: string): string {
  const letters = name
    .replace(/^@/, '')
    .trim()
    .split(/\s+/)
    .map(firstLetter)
    .filter(Boolean)
    .slice(0, 2)
    .join('');
  if (letters) return letters.toUpperCase();
  return (label.match(/[A-Za-z]/)?.[0] ?? '').toUpperCase();
}
